__webpack_require__.p = "/centers-of-excellence/zinnov-nasscom-mid-market-global-capability-centers-gccs-2025-report/";